module.exports = __webpack_public_path__ + "assets/ec82b6794efecc3e3f5c3d78d1fc67fd.mp3";